import { useMutation } from 'react-query';
import { useMemo, useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { Form, Input, Button, Row, Col, message, Layout, Image,Spin } from 'antd';
import MyCard from '../../components/MyCard/MyCard';
import MainHeader from '../../components/MainLayout/MainHeader';
import EndPoints from '../../shared/endPoints/EndPoints.json';
import useHttpClient from '../../shared/sendRequest/useHttpClient';
import btmLogo from '../../assets/btm logo.png';

export default function ResetPassword() {
  const { Header } = Layout;
  const [form] = Form.useForm();
  const history = useHistory();
  const { search } = useLocation();
  const { sendRequest } = useHttpClient();
  const searchParams = useMemo(() => new URLSearchParams(search), [search]);

  useEffect(() => {
    if (!searchParams.get('token') || !searchParams.get('username')) {
      history.push('/');
    }
  }, [searchParams, history]);

  const layout = {
    labelCol: {
      span: 12
    },
    wrapperCol: {
      span: 16
    }
  };

  const headerStyle = {
    backgroundColor: '#fff',
    position: 'fixed',
    width: '100% ',
    zIndex: 9999,
    top: 0
  };

  const buttonStyle = {
    backgroundColor: 'black',
    color: 'white',
    borderRadius: 20
  };

  const { mutate ,isLoading  } = useMutation(sendRequest, {
    onSuccess: data => {
      if (data) {
        message
          .success('Η δημιουργία νέου κωδικού πραγματοποίθηκε με επιτυχία')
          .then(() => {
            history.push('/');
          });
      }
    }
  });

  const onFinish = resetData => {
    if (resetData.newPassword !== resetData.confirmPassword) {
      message.error('Οι κωδικοί δεν ταιριάζουν');
      return;
    }
    const username = searchParams.get('username');
    const token = searchParams.get('token');
    const resetDataApiCall = { ...resetData, token, username };

    mutate({
      endpoint: EndPoints.BASEURL + EndPoints.USERACCOUNT.RESETPASSWORD,
      method: 'POST',
      bodyData: resetDataApiCall
    });
  };

  return (
    <>
      <Header style={headerStyle}>
        <MainHeader headerMenuRender={false} />
      </Header>
      <Row
        justify="center"
        align="middle"
        style={{ minHeight: '100vh', backgroundColor: '#F0F0F0' }}
      >
      
        <Col xs={24} sm={24} md={12} lg={8}>
          <Col md={{ span: 12, offset: 3 }}>
            <Image src={btmLogo} preview={false} width={320} />
          </Col>
          {isLoading ? 
          <Row justify="center">
            <Col>
                <Spin size='large' />
            </Col>
          </Row> :
          <MyCard title="Επαναφορά Κωδικού">
            <Form
              {...layout}
              name="basic"
              form={form}
              onFinish={onFinish}
              initialValues={{
                remember: true
              }}
            >
              <Form.Item
                label="Νέος Κωδικός"
                name="newPassword"
                rules={[
                  {
                    required: true,
                    message: 'Νέος Κωδικός'
                  }
                ]}
              >
                <Input.Password />
              </Form.Item>
              <Form.Item
                label="Επιβεβαίωση Νέου Κωδικού:"
                name="confirmPassword"
                rules={[
                  {
                    required: true,
                    message: 'Παρακαλώ συμπληρώστε ξανά τον Κωδικό Πρόσβασης'
                  }
                ]}
              >
                <Input.Password />
              </Form.Item>
              <Form.Item
                wrapperCol={{
                  xs: { span: 8, offset: 2 },
                  lg: { offset: 8, span: 16 }
                }}
              >
                <Button htmlType="submit" style={buttonStyle}>
                  Επιβεβαίωση
                </Button>
              </Form.Item>
            </Form>
          </MyCard>}
        </Col>
      </Row>
    </>
  );
}
